// colors
const primaryColor = "#1168FF";
const secondaryColor = "#ffffff";
const inputBgColor = "#FCFDFE";
const inputBorderColor = "#EAECEF";
const inputTextColor = "#3D4868";
const signInBtnBgColor = "#4164E3";
const forgotTextColor = "#4568E4";
const textColor = "#344062";
const userInfoTextColor = "#333333";
const userMainInfoTextColor = "#939393";
const menuIconColor = "#B6B5BB";
const menuItemHoverBgColor = "#F9FBFF";
const borderColor = "#F3F4F6";
const socMediaLinkColor = menuIconColor;
const reviewLinkColor = "#5F83C2";
const menuItemHoverColor = "black";
const formSectionHeadingColor = "#454545";
const formSectionCardShadowColor = "#E2ECFF";
const gridTextColor = "#515151";
const inputPlaceholderColor = "#C2C2C2";
const analysisRowBorderColor = "#ECF1FB"

const theme = {
  "primary-color": primaryColor,
  "secondary-color": secondaryColor,
  "input-bg-color": inputBgColor,
  "input-border-color": inputBorderColor,
  "input-text-color": inputTextColor,
  "sign-in-btn-bg-color": signInBtnBgColor,
  "forgot-text-color": forgotTextColor,
  "text-color": textColor,
  "user-info-text-color": userInfoTextColor,
  "user-main-info-text-color": userMainInfoTextColor,
  "menu-icon-color": menuIconColor,
  "menu-item-hover-bg-color": menuItemHoverBgColor,
  "border-color": borderColor,
  "soc-media-link-color": socMediaLinkColor,
  "review-link-color": reviewLinkColor,
  "menu-item-hover-color": menuItemHoverColor,
  "form-section-heading-color": formSectionHeadingColor,
  "form-section-card-shadow-color": formSectionCardShadowColor,
  "grid-text-color": gridTextColor,
  "input-placeholder-color": inputPlaceholderColor,
  "analysis-row-border-color": analysisRowBorderColor
};

export default theme;
